const redirects = [
  {
    path: '/about-ev-charging',
    redirect: {
      name: 'getting-started-en',
    },
  },
  {
    path: '/fr/a-propos-de-la-charge/',
    redirect: {
      name: 'getting-started-fr',
    },
  },
  {
    path: '/2021-22-vw-id4/',
    redirect: 'vw-en',
  },
  {
    path: '/fr/2021-22-vw-id4/',
    redirect: {
      name: 'vw-fr',
    },
  },
  {
    path: '/taycan',
    redirect: {
      name: 'porsche-en',
    },
  },
  {
    path: '/fr/taycan',
    redirect: {
      name: 'porsche-fr',
    },
  },

  {
    path: '/vw-id4/',
    redirect: {
      name: 'vw-en',
    },
  },
  {
    path: '/fr/vw-id4/',
    redirect: {
      name: 'vw-fr',
    },
  },
  {
    path: '/e-tron-charging-plan-terms/',
    redirect: {
      name: 'premium-offers-en',
    },
  },
  {
    path: '/fr/e-tron-termes/',
    redirect: {
      name: 'premium-offers-fr',
    },
  },
];

const exportedRedirects = redirects;
export default exportedRedirects;
